import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import LiveClassroomStream from "../../components/Acompanhar/LiveClassroomStream/LiveClassroomStream";
import ListStudentsAcompanhar from "../../components/Acompanhar/ListStudentsAcompanhar/ListStudentsAcompanhar";
import ProgressClass from "../../components/Acompanhar/ProgressClass/ProgressClass";
// import Notifications from "../../components/Acompanhar/NotificationAcompanhar/notifications";
import RelatoriosAcompanhar from "../../components/Acompanhar/RelatoriosAcompanhar/RelatoriosAcompanhar";
import "./Follow.css";

function FollowPage() {
    return (
        <div className="app-container">
            <Sidebar />
            <main className="main-content-follow">
                <div className="left-column-follow">
                    <div className="live-container">
                        <LiveClassroomStream />
                    </div>
                    <ListStudentsAcompanhar />
                </div>
                <div className="right-column-follow">
                    <ProgressClass />
                    {/* <Notifications /> */}
                    <RelatoriosAcompanhar /> 
                </div>
            </main>
        </div>
    );
}

export default FollowPage;